<template lang="pug">
.section
  .section-header
    template(v-if="!isDetail")
      h1 {{ $t("ui.promotion_summary") }}
    template(v-else)
      .section-header-back
        a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
          i.fas.fa-arrow-left
      h1 {{ $t("ui.promotion_summary_detail") }}
      .section-header-breadcrumb
        .breadcrumb-item
          a(href="javascript:void(0)" @click="redirect()") {{ $t("ui.promotion_summary") }}
        .breadcrumb-item.active
          span {{ $t('ui.promotion_summary_detail') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          template(v-if="!isDetail")
            .card-header
              .row.w-100              
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-user
                    DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getListSummary(true)" size="sm")
                .form-group.col-md-12.col-lg-6.col-xl-9.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getListSummary(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
                  jsonToExcel(v-if="summaryList.length > 0" mode="PromotionSummary" tbl="tblSummary" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                  jsonToExcelFull(v-if="summaryListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="PromotionSummary" tbl="tblSummaryFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                  promotionSummaryExport(v-if="summaryList.length > 0" :tbl="summaryList" tblId="tblSummary" :totalTbl="grandTotalListSummary")
                  promotionSummaryExportFull(v-if="summaryListFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="summaryListFull" tblId="tblSummaryFull" :totalTbl="grandTotalListSummaryFull")
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow"
                    :per-page="getPageSize"
                    v-model="currentPage"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                .col-12(style="max-height: 70vh; overflow: hidden;")
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
                      thead.thead-light
                        tr
                          th.text-center(width="3%")
                            span #
                          th(width="10%" v-if="!isOperator" @click="sortOrder('operator_id')")
                            span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                            .float-right
                              i(:class="changeSortKey('operator_id')")
                          th(width="10%" @click="sortOrder('promotion_id')")
                            span(:title="$t('ui.promo_id')") {{ $t('ui.promo_id') }}
                            .float-right
                              i(:class="changeSortKey('promotion_id')")
                          th(width="32%" @click="sortOrder('promotion_name')")
                            span(:title="$t('ui.promo_name')") {{ $t('ui.promo_name') }}
                            .float-right
                              i(:class="changeSortKey('promotion_name')")
                          th.text-right(width="15%" @click="sortOrder('deposit_amount')")
                            span(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
                            .float-right
                              i(:class="changeSortKey('deposit_amount')")
                          th.text-right(width="15%" @click="sortOrder('bonus_amount')")
                            span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                            .float-right
                              i(:class="changeSortKey('bonus_amount')")
                          th.text-right(width="15%" @click="sortOrder('claim_frequency')")
                            span(:title="$t('ui.claim_frequency')") {{ $t("ui.claim_frequency") }}
                            .float-right
                              i(:class="changeSortKey('claim_frequency')")
                      tbody.clusterize-content
                        tr(v-if="summaryList.length == 0")
                          td(:colspan="!isOperator ? '7': '6'").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in summaryList")
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td(v-if="!isOperator")
                            span(:title="item.operator_id") {{ item.operator_id }}
                          td
                            span(:title="item.promotion_id")
                              b-link.clickable(href="javascript:void(0);" @click="drillIn(item)") {{ item.promotion_id }}
                          td
                            span(:title="item.promotion_name") {{ item.promotion_name }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.deposit_amount, 'currency')" :class="$helpers.fontClassName(item.deposit_amount)") {{ $n(item.deposit_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.claim_frequency, 'integer')") {{ $n(item.claim_frequency, 'integer') }}
                        tr(v-if="showTotalSummary")
                          td.text-right(:colspan="!isOperator ? '4' : '3'")
                            span {{ $t("ui.grand_total") }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountSummary)" :title="$n(grandTotalDepositAmountSummary, 'currency')") {{ $n(grandTotalDepositAmountSummary, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountSummary)" :title="$n(grandTotalBonusAmountSummary, 'currency')") {{ $n(grandTotalBonusAmountSummary, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(grandTotalClaimFrequencySummary, 'currency')") {{ $n(grandTotalClaimFrequencySummary, 'integer') }}
          template(v-else)
            .card-body
              .row
                .col-2.mb-1
                  h2.section-title.mt-0 {{ selectedOperatorId }}
                .col-6.mb-1
                  jsonToExcel(v-if="detailList.length > 0" mode="PromotionSummaryDetail" tbl="tblDetail" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                  jsonToExcelFull(v-if="detailListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="PromotionSummaryDetail" tbl="tblDetailFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                  promotionSummaryDetailExport(v-if="detailList.length > 0" :tbl="detailList" tblId="tblDetail" :totalTbl="grandTotalListDetail")
                  promotionSummaryDetailExportFull(v-if="detailListFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="detailListFull" tblId="tblDetailFull" :totalTbl="grandTotalListDetailFull")
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow1"
                    :per-page="getPageSize"
                    v-model="currentPage1"
                    @input="changedPage1($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize1" size="sm")
                .col-12(style="max-height: 70vh; overflow: hidden;")
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
                      thead.thead-light
                        tr
                          th.text-center(width="3%")
                            span #
                          th(width="10%" @click="sortOrder1('member_id')")
                            span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                            .float-right
                              i(:class="changeSortKey1('member_id')")
                          th(width="10%" @click="sortOrder1('promotion_id')")
                            span(:title="$t('ui.promo_id')") {{ $t('ui.promo_id') }}
                            .float-right
                              i(:class="changeSortKey1('promotion_id')")
                          th.text-right(width="13%" @click="sortOrder1('deposit_amount')")
                            span(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
                            .float-right
                              i(:class="changeSortKey1('deposit_amount')")
                          th.text-right(width="13%" @click="sortOrder1('bonus_amount')")
                            span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                            .float-right
                              i(:class="changeSortKey1('bonus_amount')")
                          th.text-right(width="20%")
                            span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                          th.text-right(width="20%")
                            span(:title="$t('ui.provider_list')") {{ $t('ui.provider_list') }}
                          th.text-right(width="13%" @click="sortOrder1('claim_date')")
                            span(:title="$t('ui.claim_date')") {{ $t('ui.claim_date') }}
                            .float-right
                              i(:class="changeSortKey1('claim_date')")
                      tbody.clusterize-content
                        tr(v-if="detailList.length == 0")
                          td(:colspan="8").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in detailList")
                          td.text-center
                            span(:title="((currentPage1 - 1) * getPageSize + index + 1)") {{ ((currentPage1 - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.member_id") {{ item.member_id }}
                          td
                            span(:title="item.promotion_id") {{ item.promotion_id }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.deposit_amount, 'currency')" :class="$helpers.fontClassName(item.deposit_amount)") {{ $n(item.deposit_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
                          td.text-right
                            span(:title="item.remark") {{ item.remark }}
                          td.text-right
                            span(:title="item.provider_list") {{ item.provider_list }}
                          td.text-right
                            span(:title="$moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        tr(v-if="showTotalDetail")
                          td.text-right(colspan="3")
                            span {{ $t("ui.sub_total") }}
                            br
                            span {{ $t("ui.grand_total") }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmountDetail)" :title="$n(subTotalDepositAmountDetail, 'currency')") {{ $n(subTotalDepositAmountDetail, 'currency') }}
                            br
                            span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountDetail)" :title="$n(grandTotalDepositAmountDetail, 'currency')") {{ $n(grandTotalDepositAmountDetail, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmountDetail)" :title="$n(subTotalBonusAmountDetail, 'currency')") {{ $n(subTotalBonusAmountDetail, 'currency') }}
                            br
                            span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountDetail)" :title="$n(grandTotalBonusAmountDetail, 'currency')") {{ $n(grandTotalBonusAmountDetail, 'currency') }}
                          td
                          td
                          td
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import promotionSummaryExport from "@/components/report/promotionSummaryExportFull.vue";
import promotionSummaryExportFull from "@/components/report/promotionSummaryExportFull.vue";
import promotionSummaryDetailExport from "@/components/report/promotionSummaryDetailExportFull.vue";
import promotionSummaryDetailExportFull from "@/components/report/promotionSummaryDetailExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    jsonToExcelFull,
    promotionSummaryExport,
    promotionSummaryExportFull,
    promotionSummaryDetailExport,
    promotionSummaryDetailExportFull
  },
  data: () => ({
    loading: false,
    loading2: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },    
    dateRange: {
      startDate: null,
      endDate: null
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "promotion_id",
    sortType: "asc",
    currentPage1: 1,
    totalRow1: 0,
    sortKey1: "claim_date",
    sortType1: "desc",
    isDetail: false,
    searchID: "",
    selectedPromoId: null,
    selectedOperatorId: null,
    summaryList: [],
    summaryListFull: [],
    detailList: [],
    detailListFull: [],
    grandTotalListSummary: [],
    grandTotalListSummaryFull: [],
    grandTotalListDetail: [],
    grandTotalListDetailFull: [],
    grandTotalDepositAmountSummary: 0,
    grandTotalBonusAmountSummary: 0,
    grandTotalClaimFrequencySummary: 0,
    subTotalDepositAmountDetail: 0,
    grandTotalDepositAmountDetail: 0,
    subTotalBonusAmountDetail: 0,
    grandTotalBonusAmountDetail: 0,
    showTotalSummary: false,
    showTotalDetail: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }
      }

      this.getSummaryList(true);
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getSummaryList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    sortOrder1(key) {
      if (this.sortKey1 == key)
        this.sortType1 = this.sortType1 == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey1 = key;
        this.sortType1 = 'asc';
      }
      this.getDetailList(true);
    },
    changeSortKey1(key) {
      if (this.sortKey1 != key)
        return 'fas fa-sort';
      else if (this.sortKey1 == key && this.sortType1 == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey1 == key && this.sortType1 == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getListSummary(isSearch) {
      if (this.checkDateRange()) {
        this.getSummaryList(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getSummaryListFull(isSearch);
        }
      } else {
        this.clearTotalSummary();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListSummary(true);
    },
    redirect() {
      this.isDetail = false;
      this.clearTotalDetail();
      this.getListSummary();
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getSummaryList: function(isSearch) {
      if (this.checkDateRange()) {
        this.isDetail = false;

        if (isSearch) this.currentPage = 1;

        let url = config.promotionSummaryUrl();
        this.setReportStatementParam();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalSummary();
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.summary.length > 0) {
                    this.showTotalSummary = true;

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalDepositAmountSummary = response.data.ds.grand_total[0]["deposit_amount"];
                      this.grandTotalBonusAmountSummary = response.data.ds.grand_total[0]["bonus_amount"];
                      this.grandTotalClaimFrequencySummary = response.data.ds.grand_total[0]["claim_frequency"];
                    }

                    this.grandTotalListSummary = response.data.ds.grand_total;
                    this.summaryList = response.data.ds.summary;
                  } else {
                    this.clearTotalSummary();
                  }
                } else {
                  this.clearTotalSummary()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearTotalSummary();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getSummaryListFull: function(isSearch ) {
      if (this.checkDateRange()) {
        if (isSearch) this.currentPage = 1;

        let url = config.promotionSummaryUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.summaryListFull = response.data.ds.summary;
                  this.grandTotalListSummaryFull = response.data.ds.grand_total;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    getListDetail(isSearch) {
      if (this.checkDateRange()) {
        this.getDetailList(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getDetailListFull(isSearch);
        }
      } else {
        this.clearTotalDetail();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    drillIn: function (e) {
      this.isDetail = true;
      this.selectedPromoId = e.promotion_id;
      this.selectedOperatorId = e.operator_id;
      this.totalRow1 = 0;
      this.detailList = [];
      this.detailListFull = [];
      this.getListDetail(true);
    },
    getDetailList: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.promotionSummaryDetailUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.selectedOperatorId,
          promotion_id: this.selectedPromoId,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType1,
          sort_key: this.sortKey1,
          page_number: this.currentPage1,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalDetail();
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.pageLvl = 'detail';
                  if(response.data.ds.summarydetail.length > 0) {
                    this.showTotalDetail = true;

                    response.data.ds.summarydetail.forEach(value => {
                      this.subTotalDepositAmountDetail = parseFloat(this.subTotalDepositAmountDetail) + parseFloat(value["deposit_amount"]);
                      this.subTotalBonusAmountDetail = parseFloat(this.subTotalBonusAmountDetail) + parseFloat(value["bonus_amount"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalDepositAmountDetail = response.data.ds.grand_total[0]["deposit_amount"];
                      this.grandTotalBonusAmountDetail = response.data.ds.grand_total[0]["bonus_amount"];
                    }

                    this.detailList = response.data.ds.summarydetail;
                    this.grandTotalListDetail = response.data.ds.grand_total;
                    this.totalRow1 = response.data.ds.summarydetail.length > 0 ? this.detailList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalDetail();
                  }
                } else {
                  this.clearTotalDetail();
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearTotalDetail();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getDetailListFull: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.promotionSummaryDetailUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.selectedOperatorId,
          promotion_id: this.selectedPromoId,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType1,
          sort_key: this.sortKey1,
          page_number: this.currentPage1,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.detailListFull = response.data.ds.summarydetail;
                  this.grandTotalListDetailFull = response.data.ds.grand_total;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    clearTotalDetail() {
      this.showTotalDetail = false
      this.detailList = []
      this.totalRow1 = 0
      this.subTotalDepositAmountDetail = 0
      this.grandTotalDepositAmountDetail = 0
      this.subTotalBonusAmountDetail = 0
      this.grandTotalBonusAmountDetail = 0
    },
    clearTotalSummary() {
      this.showTotalSummary = false
      this.summaryList = []
      this.totalRow = 0
      this.grandTotalDepositAmountSummary = 0
      this.grandTotalBonusAmountSummary = 0
      this.grandTotalClaimFrequencySummary = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSummaryList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getSummaryList();
    },
    changedPageSize1: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDetailList(true);
    },
    changedPage1: function(pageNo) {
      this.currentPage = pageNo;
      this.getDetailList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>